import React from 'react';
import { Box, InputBase, useTheme } from '@mui/material';
import AiSearchIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/AiSearch.js';

interface SearchInputProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement> | string) => void;
  onKeyPress?: (event: React.KeyboardEvent) => void;
  placeholder?: string;
  fullWidth?: boolean;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onKeyPress,
  placeholder = "Ask a question about...",
  fullWidth = false,
}) => {
  const theme = useTheme();
  const tokens = (theme as any).tokens;
  
  // Get AI Primary gradient colors from Lens theme tokens
  const gradientStart = tokens?.semantic?.color?.action?.aiPrimary?.defaultGradientStart?.value ?? '#b11f62';
  const gradientEnd = tokens?.semantic?.color?.action?.aiPrimary?.defaultGradientEnd?.value ?? '#1c4ee4';

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event);
  };

  return (
    <Box 
      sx={{ 
        position: 'relative', 
        width: fullWidth ? '100%' : 'auto' 
      }}
    >
      <Box 
        sx={{
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          isolation: 'isolate',
          height: '40px',
          background: `linear-gradient(174deg, ${gradientStart} 0%, ${gradientEnd} 100%)`,
          borderRadius: '8px',
          padding: '2px',
          flex: 'none',
          alignSelf: 'stretch',
          flexGrow: 0,
          width: '100%'
        }}
      >
         <Box 
           sx={(theme) => ({
             display: 'flex',
             flexDirection: 'column',
             justifyContent: 'center',
             alignItems: 'flex-start',
             padding: `${theme.spacing(0.75)} ${theme.spacing(1.25)}`,
             height: '100%',
             backgroundColor: theme.palette.background.paper,
             borderRadius: '7px',
             width: '100%',
           })}
         >
          <Box 
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '8px',
              width: '100%',
              height: '100%',
            }}
          >
            <Box 
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '24px',
                height: '24px',
                flexShrink: 0,
              }}
            >
              <AiSearchIcon />
            </Box>
             <InputBase
               value={value}
               onChange={handleInputChange}
               onKeyPress={onKeyPress}
               placeholder={placeholder}
               sx={{
                 flex: 1,
                 typography: 'body1',
                 color: 'text.secondary',
                 '& .MuiInputBase-input': {
                   padding: 0,
                   border: 'none',
                   background: 'transparent',
                   '&::placeholder': {
                     color: 'text.secondary',
                     opacity: 1,
                   },
                   '&:focus': {
                     outline: 'none',
                   },
                 },
               }}
             />
          </Box>
        </Box>
      </Box>
      
    </Box>
  );
};

export default SearchInput;